import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { configUtils } from 'conversional-utils';
import buildBranch from '../builder';
export function render(node, path) {
    if (!node.Content)
        return null;
    var _a = node.Content, type = _a.type, props = _a.props, componentKey = _a.componentKey;
    var component = get(window['customComponentsMap'], type, {});
    if (!component)
        return null;
    var config = component.config;
    var evaluatedConfig = configUtils.evaluateCustomComponentProps(config, props);
    var evaluatedConfigContent = evaluatedConfig['Content'];
    if (isEmpty(evaluatedConfigContent) ||
        isEmpty(evaluatedConfigContent.format) ||
        isEmpty(evaluatedConfigContent.type))
        return null;
    return buildBranch("".concat(componentKey !== null && componentKey !== void 0 ? componentKey : props.componentKey) || "".concat(path.replace(/\//g, "_")), evaluatedConfig, undefined, undefined);
}
